let server = ""
if(!window.location.href.includes("localhost")){
    server = "/__extra/GuideSearchNew-Nofos"
}
module.exports = server
